import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Import Polaris styles directly to prevent dynamic loading issues
import '@shopify/polaris/build/esm/styles.css';

// Ensure proper styling for Polaris
document.body.style.margin = '0';
document.body.style.fontFamily = 'Inter, system-ui, -apple-system, sans-serif';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);